import { ENGLISH, SPANISH } from "../../utils/constants";

export const viewGalleryLabel = {
  [SPANISH]: "Ver Galería",
  [ENGLISH]: "View Gallery",
};
